import { Component, OnInit, ViewContainerRef, ViewChild, ViewEncapsulation, ElementRef } from '@angular/core';
import { Menu } from '@grapecity/wijmo.input';
import { ActivatedRoute, Router } from '@angular/router';
import { CellType, FlexGrid } from '@grapecity/wijmo.grid';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW0300InputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-input.model';
import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { KYMW0300Component } from '../../../commons/kymw03/kymw0300/kymw0300.component';
import { GetCodeListService } from '../../../commons/kymw02/api-services/get-code-list.service';

import {
  KYMW1001UserType,
  KYMW7002Model,
  KYMW7002ViewType,
  KYMW7002SelectionFlg,
  KYMW7002PricePatternValue,
  KYMW7002OrderUnitType,
  KYMW7002NewUnitType,
  PARENT_PAGE_ID,
  COUNT_PER_PAGE,
  MEDIUM_TYPE_STOCK_ONLY,
  PricePatternList,
  NewUnitTypeList,
} from './kymw7002.model';
import { GetApprovalFlowTypeInfoService } from './api-service/get-approval-flow-type-info.service';
import { GetSelectedGoodsFlgResultService } from './api-service/get-selected-goods-flg-result.service';
import { GetCandidateSuggestionGoodsListService } from './api-service/get-candidate-suggestion-goods-list.service';
import { GetSuggestionGoodsInfoService } from './api-service/get-suggestion-goods-info.service';
import { GetSuggestionGoodsListInfoService } from './api-service/get-suggestion-goods-list-info.service';
import { GetSuggestionGoodsListOutputInfoService } from './api-service/get-suggestion-goods-list-output-info.service';
import {
  RegistSuggestionGoodsInfoService,
  ProcessStatus,
} from './api-service/regist-suggestio-goods-info.service';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';

import type { Params } from '@angular/router';
import type { SuggestionGoods } from './vo/suggestion-goods.model';
import type { CandidateSuggestionGoods } from './vo/candidate-suggestion-goods.model';
import { KYMW0300Model } from '../../../commons/kymw03/kymw0300/kymw0300.model';

/** コンテキストメニュー用インターフェース */
export interface ContextMenu {
  /** メニューアイテム表示名 */
  caption: string;
  /** コマンド */
  cmd: string;
  /** 活性フラグ */
  enabled: boolean;
}

@Component({
  selector: 'app-kymw7002',
  templateUrl: './kymw7002.component.html',
  styleUrls: ['./kymw7002.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW7002Component extends PlessViewHelperSub implements OnInit {
  model = new KYMW7002Model();
  // コンテキストメニュー
  private contextMenuCandidateList: Menu;
  private contextMenuSuggestList: Menu;
  private selectedPCodeByContextSuggestList: string = '';
  private selectedPCodeByContextCandidateList: string = '';
  // 商品検索画面のモデル
  private kymw0300Model: KYMW0300Model = new KYMW0300Model();
  private kymw0300InputModel: KYMW0300InputModel = null;

  @ViewChild('tbx_CatalogId', { static: true }) tbx_CatalogId: ElementRef;
  @ViewChild('tbx_MediumName', { static: true }) tbx_MediumName: ElementRef;
  @ViewChild('tbx_Feature', { static: true }) tbx_Feature: ElementRef;
  @ViewChild('btn_SearchGoods', { static: true }) btn_SearchGoods: ElementRef;
  @ViewChild('btn_ToggleView', { static: true }) btn_ToggleView: ElementRef;
  @ViewChild('btn_SelectGoods', { static: true }) btn_SelectGoods: ElementRef;
  @ViewChild('btn_CancelSelection', { static: true }) btn_CancelSelection: ElementRef;
  @ViewChild('dtg_CandidateSuggestionGoodsList', { static: true }) dtg_CandidateSuggestionGoodsList: FlexGrid;
  @ViewChild('dtg_SuggestionGoodsList', { static: true }) dtg_SuggestionGoodsList: FlexGrid;

  pricePatternList = PricePatternList;
  newUnitTypeList = NewUnitTypeList;

  // 必須項目判定用
  pricePatternRequired: boolean = false;
  thisTimeSupplyPriceStandardRequired: boolean = false;
  thisTimeCostPriceStandardRequired: boolean = false;
  stockNumRequired: boolean = false;
  orderUnitTypeRequired: boolean = false;
  newUnitTypeRequired: boolean = false;
  planNumRequired: boolean = false;

  /**
   * Creates an instance of KYMW7002 Component.
   * @param {Router} router
   * @param {ActivatedRoute} activatedRoute
   * @param {KYMW00Model} kymw00Model
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetApprovalFlowTypeInfoService} getApprovalFlowTypeInfoService
   * @param {GetSelectedGoodsFlgResultService} getSelectedGoodsFlgResultService
   * @param {GetCandidateSuggestionGoodsListService} getCandidateSuggestionGoodsListService
   * @param {GetSuggestionGoodsInfoService} getSuggestionGoodsInfoService
   * @param {GetSuggestionGoodsListInfoService} getSuggestionGoodsListInfoService
   * @param {GetSuggestionGoodsListOutputInfoService} getSuggestionGoodsListOutputInfoService
   * @param {RegistSuggestionGoodsInfoService} registSuggestionGoodsInfoService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @memberof KYMW7006Component
   */
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private getApprovalFlowTypeInfoService: GetApprovalFlowTypeInfoService,
    private getSelectedGoodsFlgResultService: GetSelectedGoodsFlgResultService,
    private getCandidateSuggestionGoodsListService: GetCandidateSuggestionGoodsListService,
    private getSuggestionGoodsInfoService: GetSuggestionGoodsInfoService,
    private getSuggestionGoodsListInfoService: GetSuggestionGoodsListInfoService,
    private getSuggestionGoodsListOutputInfoService: GetSuggestionGoodsListOutputInfoService,
    private registSuggestionGoodsInfoService: RegistSuggestionGoodsInfoService,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private getCodeListService: GetCodeListService,
  ) {
    super(kymw00Model);
  }

  ngOnInit() {
    this.componentName = 'KYMW7002';

    // ログインユーザ情報取得
    this.getUserInfo();

    // コンテキストメニュー設定
    this.setContextMenu();

    // 遷移元が「特集商品提案状況確認（取引先用）」の場合、パラメータ取得
    this.activatedRoute.queryParams.subscribe(params => {
      this.setParamsFromQuery(params);
      this.hideGridColumnSuggestList();
      this.getSelectedGoodsFlgResult();
    });

    // チェックボックスのあたり判定制御
    this.dtg_CandidateSuggestionGoodsList.hostElement.addEventListener("click", (e: MouseEvent) => {
      const ht = this.dtg_CandidateSuggestionGoodsList.hitTest(e.pageX, e.pageY);
      if (ht.cellType === CellType.Cell && ht.col === 0) {
        const val = this.dtg_CandidateSuggestionGoodsList.getCellData(ht.row, ht.col, false);
        this.dtg_CandidateSuggestionGoodsList.setCellData(ht.row, ht.col, val ? false : true);
      }
    });
    this.dtg_SuggestionGoodsList.hostElement.addEventListener("click", (e: MouseEvent) => {
      const ht = this.dtg_SuggestionGoodsList.hitTest(e.pageX, e.pageY);
      if (ht.cellType === CellType.Cell && ht.col === 0 && !this.model.isDisableGridColumnsSuggestList) {
        const val = this.dtg_SuggestionGoodsList.getCellData(ht.row, ht.col, false);
        this.dtg_SuggestionGoodsList.setCellData(ht.row, ht.col, val ? false : true);
      }
    });

    // 表のinput必須項目設定
    const mediumType = this.model.mediumType;
    const userType = this.model.userType;
    // 価格パターン
    this.pricePatternRequired = (this.model.userType === KYMW1001UserType.WHOLESALE ||
      (userType === KYMW1001UserType.PLANNING_SUPPORT && mediumType !== MEDIUM_TYPE_STOCK_ONLY));
    // 今回供給価格
    this.thisTimeSupplyPriceStandardRequired = (userType === KYMW1001UserType.WHOLESALE ||
      (userType === KYMW1001UserType.PLANNING_SUPPORT && mediumType !== MEDIUM_TYPE_STOCK_ONLY));
    // 今回仕入価格
    this.thisTimeCostPriceStandardRequired = (userType === KYMW1001UserType.WHOLESALE);
    // 在庫数
    this.stockNumRequired = (userType === KYMW1001UserType.WHOLESALE && mediumType === MEDIUM_TYPE_STOCK_ONLY);
    // 発注単位
    this.orderUnitTypeRequired = (userType === KYMW1001UserType.WHOLESALE);
    // 新規区分
    this.newUnitTypeRequired = (userType === KYMW1001UserType.WHOLESALE);
    // 計画数
    this.planNumRequired = (userType === KYMW1001UserType.WHOLESALE && mediumType !== MEDIUM_TYPE_STOCK_ONLY) ||
      (userType === KYMW1001UserType.PLANNING_SUPPORT && mediumType !== MEDIUM_TYPE_STOCK_ONLY);
      
    // 承認フロー区分情報を取得
    this.getApprovalFlowTypeInfo();

    // 発注単位区分を取得
    this.getCodeListService.execute('ct026', '', this.model, 'orderUnitTypeListSearchData',() => {
      this.model.orderUnitTypeList = [];
      for (const item of this.model.orderUnitTypeListSearchData) {
        this.model.orderUnitTypeList.push({label:item.CodeName,value:item.CodeValue});
      }
    }, null, null);

  }

  /**
   * ページャの前頁ボタンをクリックした時のハンドラ（提案候補商品一覧）
   * @memberof KYMW7002Component
   */
  eventBackHandlerCandidateList(): void {
    // 現在のページ番号-1を設定し、リストを取得
    if (this.model.currentPageNoCandidateList > 1) {
      const newPageNo = this.model.currentPageNoCandidateList - 1;
      this.showCandidateSuggestionGoodsList(newPageNo);
    }
  }

  /**
   * ページャの次頁ボタンをクリックした時のハンドラ（提案候補商品一覧）
   * @memberof KYMW7002Component
   */
  eventNextHandlerCandidateList(): void {
    // 現在のページ番号+1を設定し、リストを取得
    if (this.model.currentPageNoCandidateList < this.model.endPageNoCandidateList) {
      const newPageNo = this.model.currentPageNoCandidateList + 1;
      this.showCandidateSuggestionGoodsList(newPageNo);
    }
  }

  /**
   * ページャの前頁ボタンをクリックした時のハンドラ（提案商品一覧）
   * @memberof KYMW7002Component
   */
  eventBackHandlerSuggestList(): void {
    // 現在のページ番号-1を設定し、リストを取得
    if (this.model.currentPageNoSuggestList > 1) {
      const newPageNo = this.model.currentPageNoSuggestList - 1;
      this.showSuggestionGoodsList(newPageNo);
    }
  }

  /**
   * ページャの次頁ボタンをクリックした時のハンドラ（提案商品一覧）
   * @memberof KYMW7002Component
   */
  eventNextHandlerSuggestList(): void {
    // 現在のページ番号+1を設定し、リストを取得
    if (this.model.currentPageNoSuggestList < this.model.endPageNoSuggestList) {
      const newPageNo = this.model.currentPageNoSuggestList + 1;
      this.showSuggestionGoodsList(newPageNo);
    }
  }

  /**
   * 商品検索ボタン クリック時処理
   * @memberof KYMW7002Component
   */
  eventSearchGoods_CLICKHandler() {
    // 商品検索ダイアログ用のインプットモデル生成（初回表示時のみ初期化）
    if (!this.kymw0300InputModel) {
      this.kymw0300InputModel = new KYMW0300InputModel();
    }

    this.kymw0300InputModel.catalogSearchFlg = 0;       // 企画検索フラグ(0: 表示しない)

    // 商品検索画面をモーダルで表示
    const componentRef = this.dialogService.openModal(KYMW0300Component);
    const instance = componentRef.componentInstance as KYMW0300Component;
    instance.parent = this;
    instance.setInterfaceParam(this.kymw0300InputModel); // 最後に保持した検索条件をセット
    // 「候補リスト作成」ボタン押下時処理
    instance.setKYMW0300Parameter = (kymw0300OutputModel: KYMW0300OutputModel) => {
      this.kymw0300InputModel = this.kymw0300Model.getKYMW0300SearchHistory(kymw0300OutputModel);

      // 提案候補商品一覧 ページャー関連項目初期化
      this.clearCandidateSuggestionGoodsList();

      // 商品検索項目 kymw0300OutputModel をリクエストに渡す
      this.getAllCandidateSuggestionGoodsList(kymw0300OutputModel, 1);
    };
    // ダイアログ閉じるアイコンボタン押下時処理
    instance.closeFunction = () => componentRef.close();
  }

  /**
   * 表示切替ボタン クリック時処理
   * @memberof KYMW7002Component
   */
  eventToggleView_CLICKHandler() {
    this.model.isHiddenCandidateList = !this.model.isHiddenCandidateList;
  }

  /**
   * 提案候補商品一覧 選定ボタン クリック時処理
   * @memberof KYMW7002Component
   */
  eventSelectGoods_CLICKHandler() {
    // 選定対象のPコード配列を用意
    const targetPCodeList = [] as string[];
    for (const item of this.model.candidateSuggestionGoodsAllList) {
      if (item.check) {
        targetPCodeList.push(item.PCode);
      }
    }

    if (targetPCodeList.length === 0) {
      // 未選択の場合、エラーダイアログを表示
      this.dialogService.openAlertGetMessage('E0100');
      return;
    }

    const isListChanged = this.setSuggestionGoodsList(targetPCodeList);

    if (isListChanged) {
      // 一覧出力ボタンを非活性にする
      this.model.isDisableButtonOutput = true;
    }
  }

  /**
   * 提案候補商品一覧 右クリック実行時処理
   * @memberof KYMW7002Component
   */
  eventSelectGoodsByContextMenu_CLICKHandler() {
    // 選定対象のPコード配列を用意
    const targetPCodeList: string[] = [this.selectedPCodeByContextCandidateList];
    const isListChanged = this.setSuggestionGoodsList(targetPCodeList);

    if (isListChanged) {
      // 一覧出力ボタンを非活性にする
      this.model.isDisableButtonOutput = true;
    }
  }

  /**
   * 提案商品一覧 選定解除ボタン クリック時処理
   * @memberof KYMW7002Component
   */
  eventCancelSelection_CLICKHandler() {
    // 提案商品一覧の中からチェックが入っているものがあるか確認
    const hasChecked = this.model.suggestionGoodsAllList.some(item => item.check);
    if (!hasChecked) {
      // 未選択の場合、エラーダイアログを表示
      this.dialogService.openAlertGetMessage('E0100');
      return;
    }

    // 提案商品一覧の中からチェックが入っているものだけを削除する
    this.model.suggestionGoodsAllList = this.model.suggestionGoodsAllList.filter(item => !item.check);
    // 最終ページ番号
    this.model.endPageNoSuggestList = Math.max(1, Math.ceil(this.model.suggestionGoodsAllList.length / COUNT_PER_PAGE));
    // 現在ページ番号
    this.model.currentPageNoSuggestList = Math.min(this.model.currentPageNoSuggestList, this.model.endPageNoSuggestList);
    // 現在ページの一覧更新
    this.showSuggestionGoodsList(this.model.currentPageNoSuggestList);
    // チェックボックスクリア
    this.clearListCheckSuggestList();

    // 一覧出力ボタンを非活性にする
    this.model.isDisableButtonOutput = true;
  }

  /**
   * 提案商品一覧 右クリック実行時処理
   * @memberof KYMW7002Component
   */
  eventCancelSelectionByContextMenu_CLICKHandler() {
    // 提案商品一覧の中から右クリックで選択されたものだけを削除する
    this.model.suggestionGoodsAllList = this.model.suggestionGoodsAllList.filter(item => item.PCode !== this.selectedPCodeByContextSuggestList);
    // 最終ページ番号
    this.model.endPageNoSuggestList = Math.max(1, Math.ceil(this.model.suggestionGoodsAllList.length / COUNT_PER_PAGE));
    // 現在ページ番号
    this.model.currentPageNoSuggestList = Math.min(this.model.currentPageNoSuggestList, this.model.endPageNoSuggestList);
    // 現在ページの一覧更新
    this.showSuggestionGoodsList(this.model.currentPageNoSuggestList);
    // チェックボックスクリア
    this.clearListCheckSuggestList();

    // 一覧出力ボタンを非活性にする
    this.model.isDisableButtonOutput = true;
  }

  /**
   * フッタ 一時保存ボタン クリック時処理
   * @memberof KYMW7002Component
   */
  eventSaveTemporary_CLICKHandler() {
    // 未入力項目チェック
    const isInvalid = this.isInvalidRequestForRegister();
    if (isInvalid) {
      this.dialogService.openAlertGetMessage('W0048'); // エラーメッセージ「未入力の項目があります。」
      return;
    }

    this.dialogService.openAlertGetMessage('Q0108', ['提案商品情報'], (closeDetail: number) => {
      if (closeDetail === PlessAlert.Yes) {
        this.registSuggestionGoodsInfo(ProcessStatus.SAVE_TEMPORARY);
      }
    });
  }

  /**
   * フッタ 提案ボタン クリック時処理
   * @memberof KYMW7002Component
   */
  eventSuggest_CLICKHandler() {
    // 未入力項目チェック
    const isInvalid = this.isInvalidRequestForRegister();
    if (isInvalid) {
      this.dialogService.openAlertGetMessage('W0048'); // エラーメッセージ「未入力の項目があります。」
      return;
    }

    // 確認ダイアログ表示後、登録 // 結果メッセージ「選定した商品情報で提案を行います。よろしいですか。」
    this.dialogService.openAlertGetMessage('Q0181', [], (closeDetail: number) => {
      if (closeDetail === PlessAlert.Yes) {
        this.registSuggestionGoodsInfo(ProcessStatus.SUGGEST);
      }
    });
  }

  /**
   * フッタ 提案商品一覧出力ボタン クリック時処理
   * @memberof KYMW7002Component
   */
  eventSuggestionGoodsListOut_CLICKHandler() {
    const targetList = this.model.suggestionGoodsAllList;
    if (targetList.length > 0) {
      this.getSuggestionGoodsListOutputInfo();
    } else {
      // 対象件数が 0 件の場合、エラーダイアログを表示
      this.dialogService.openAlertGetMessage('E0573'); // エラーメッセージ「提案商品がありません。」
    }
  }

  /**
   * 提案商品一覧 価格パターン 変更時処理 SuggestionGoods
   * @memberof KYMW7002Component
   */
  eventPricePattern_CHANGEHandler(selectedItem: SuggestionGoods) {
    // 価格パターンに対応した価格に変更する
    if (selectedItem.PricePattern === KYMW7002PricePatternValue.STANDARD) {
      selectedItem.ThisTimeSupplyPriceStandard = selectedItem.SupplyPriceStandard;
      selectedItem.ThisTimeCostPriceStandard = selectedItem.CostPriceStandard;
    } else if (selectedItem.PricePattern === KYMW7002PricePatternValue.SPECIAL1) {
      selectedItem.ThisTimeSupplyPriceStandard = selectedItem.SupplyPriceSpecial1;
      selectedItem.ThisTimeCostPriceStandard = selectedItem.CostPriceSpecial1;
    } else if (selectedItem.PricePattern === KYMW7002PricePatternValue.SPECIAL2) {
      selectedItem.ThisTimeSupplyPriceStandard = selectedItem.SupplyPriceSpecial2;
      selectedItem.ThisTimeCostPriceStandard = selectedItem.CostPriceSpecial2;
    } else if (selectedItem.PricePattern === KYMW7002PricePatternValue.SPECIAL3) {
      selectedItem.ThisTimeSupplyPriceStandard = null;
      selectedItem.ThisTimeCostPriceStandard = null;
    }
    // 一覧出力ボタンを非活性にする
    this.model.isDisableButtonOutput = true;
  }

  /**
   * 提案商品一覧 発注単位 変更時処理
   * @memberof KYMW7002Component
   */
  eventOrderUnitType_CHANGEHandler(selectedOrderUnitType: KYMW7002OrderUnitType) {
    // 一覧出力ボタンを非活性にする
    this.model.isDisableButtonOutput = true;
  }

  /**
   * 提案商品一覧 新規区分 変更時処理
   * @memberof KYMW7002Component
   */
  eventNewUnitType_CHANGEHandler(selectedNewUnitType: KYMW7002NewUnitType) {
    // 一覧出力ボタンを非活性にする
    this.model.isDisableButtonOutput = true;
  }

  /**
   * ログイン情報から必要な値を取得する
   */
  private getUserInfo(): void {
    this.model.userID = this.kymw00Model.kymw1001Model.loginUserInfo.UserID;
    const userType = this.kymw00Model.kymw1001Model.loginUserInfo.AssociatedUserType;
    this.model.planningSupportFlg = this.kymw00Model.kymw1001Model.loginUserInfo.PlanningSupportFlg;
    // ユーザ区分が取引先の場合
    if (userType === KYMW00Model.ASSOCIATED_USER_TYPE_SUPPLIER) {
      this.model.userType = KYMW1001UserType.WHOLESALE;
    } else {
      this.model.userType = KYMW1001UserType.PLANNING_SUPPORT;
    }
    this.model.supplierCode = this.kymw00Model.kymw1001Model.loginUserInfo.SupplierCode;
  }

  /**
   * コンテキストメニューを追加
   */
  private setContextMenu(): void {
    // コンテキストメニュー作成 (提案候補商品一覧用)
    this.contextMenuCandidateList = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '選定', cmd: 'selectGoods', enabled: false },
      ] as ContextMenu[],
      command: { canExecuteCommand: (item: ContextMenu) => item.enabled }, // 各項目の活性制御
      itemClicked: () => {
        if (this.contextMenuCandidateList.selectedValue === 'selectGoods') {
          this.eventSelectGoodsByContextMenu_CLICKHandler();
        }
      },
    });

    // コンテキストメニュー表示処理 (提案候補商品一覧用)
    this.dtg_CandidateSuggestionGoodsList.hostElement.addEventListener('contextmenu', e => {
      // イベントを停止後、メニュー表示
      e.preventDefault();

      // コンテキストメニューの活性/非活性 制御
      let isEnabled = this.model.selectedGoodsFlgResult.SelectionFlg !== KYMW7002SelectionFlg.SELECTED
      this.contextMenuCandidateList.itemsSource.forEach((item: ContextMenu) => {
        item.enabled = isEnabled;
      });

      // コンテキストメニュー表示
      DataGridUtil.showContextMenu(this.dtg_CandidateSuggestionGoodsList, this.contextMenuCandidateList, e);

      // 選択行のインデックスを取得
      const ht = this.dtg_CandidateSuggestionGoodsList.hitTest(e.pageX, e.pageY);
      const selectRowIndex = ht.row;
      // 処理対象のPコードを保持
      this.selectedPCodeByContextCandidateList = (selectRowIndex >= 0) ? this.model.candidateSuggestionGoodsPageList[selectRowIndex].PCode : '';
    });

    // コンテキストメニュー作成 (提案商品一覧用)
    this.contextMenuSuggestList = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '選定解除', cmd: 'cancelSelection', enabled: false },
      ] as ContextMenu[],
      command: { canExecuteCommand: (item: ContextMenu) => item.enabled }, // 各項目の活性制御
      itemClicked: () => {
        if (this.contextMenuSuggestList.selectedValue === 'cancelSelection') {
          this.eventCancelSelectionByContextMenu_CLICKHandler();
        }
      },
    });

    // コンテキストメニュー表示処理 (提案商品一覧用)
    this.dtg_SuggestionGoodsList.hostElement.addEventListener('contextmenu', e => {
      // イベントを停止後、メニュー表示
      e.preventDefault();

      // コンテキストメニューの活性/非活性 制御
      let isEnabled = this.model.selectedGoodsFlgResult.SelectionFlg !== KYMW7002SelectionFlg.SELECTED;
      this.contextMenuSuggestList.itemsSource.forEach((item: ContextMenu) => {
        item.enabled = isEnabled;
      });

      // コンテキストメニュー表示
      DataGridUtil.showContextMenu(this.dtg_SuggestionGoodsList, this.contextMenuSuggestList, e);

      // 選択行のインデックスを取得
      const ht = this.dtg_SuggestionGoodsList.hitTest(e.pageX, e.pageY);
      const selectRowIndex = ht.row;
      // 処理対象のPコードを保持
      this.selectedPCodeByContextSuggestList = (selectRowIndex >= 0) ? this.model.suggestionGoodsPageList[selectRowIndex].PCode : '';
    });

  }

  /**
   * ユーザ区分および媒体区分によって、グリッドカラムを非表示にする（提案商品一覧）
   */
  private hideGridColumnSuggestList(): void {
    const mediumType = this.model.mediumType;
    const userType = this.model.userType;

    // 仕入価格(通常) 表示フラグ
    if ((mediumType !== MEDIUM_TYPE_STOCK_ONLY) && (userType === KYMW1001UserType.PLANNING_SUPPORT)) {
      this.model.isVisibleColumnCostPriceStandard = false;
    }
    // 今回仕入価格 表示フラグ
    if ((mediumType !== MEDIUM_TYPE_STOCK_ONLY) && (userType === KYMW1001UserType.PLANNING_SUPPORT)) {
      this.model.isVisibleColumnThisTimeCostPriceStandard = false;
    }
    // 在庫数 表示フラグ
    if ((mediumType !== MEDIUM_TYPE_STOCK_ONLY) &&
      (userType === KYMW1001UserType.WHOLESALE || userType === KYMW1001UserType.PLANNING_SUPPORT)
    ) {
      this.model.isVisibleColumnStockNumd = false;
    }
    // 発注単位 表示フラグ
    if ((mediumType !== MEDIUM_TYPE_STOCK_ONLY) && (userType === KYMW1001UserType.PLANNING_SUPPORT)) {
      this.model.isVisibleColumnOrderUnitType = false;
    }
    // 新規区分 表示フラグ
    if ((mediumType !== MEDIUM_TYPE_STOCK_ONLY) && (userType === KYMW1001UserType.PLANNING_SUPPORT)) {
      this.model.isVisibleColumnNewUnitType = false;
    }
    // 計画数 表示フラグ
    if ((mediumType === MEDIUM_TYPE_STOCK_ONLY) && (userType === KYMW1001UserType.WHOLESALE)) {
      this.model.isVisibleColumnPlanNum = false;
    }
    // 注文番号 表示フラグ
    if ((mediumType === MEDIUM_TYPE_STOCK_ONLY) && (userType === KYMW1001UserType.WHOLESALE)) {
      this.model.isVisibleColumnOrderNum = false;
    }
  }

  /**
   * システムエラーアラート表示
   * @memberof KYMW7002Component
   */
  private showSystemErrorAlert() {
    this.dialogService.openAlert('システムエラーが発生しました。', 'E', undefined, () => {
      // 親画面に戻す
      this.router.navigate([PARENT_PAGE_ID]);
    });
  }

  /**
   * クエリパラメータから値を取得して保持・設定する
   * @memberof KYMW7002Component
   */
  private setParamsFromQuery(params: Params) {
    // 表示区分
    if ('ViewType' in params) {
      const viewType = params['ViewType'];
      if (viewType === KYMW7002ViewType.HISTORY) {
        this.model.viewType = KYMW7002ViewType.HISTORY;
        this.disableSearchAndEditControl();
      } else {
        this.model.viewType = KYMW7002ViewType.CREATE;
      }
    }
    // 企画回
    if ('CatalogIdName' in params) {
      this.model.catalogId = params['CatalogIdName'];
    }
    // 受注コード
    if ('OrderCode' in params) {
      this.model.orderCode = params['OrderCode'];
    }
    // 媒体区分
    if ('mediumType' in params) {
      this.model.mediumType = params['mediumType'];
    }
    // 媒体名
    if ('MediumName' in params) {
      this.model.mediumName = params['MediumName'];
    }
    // 特集コード
    if ('FeatureCode' in params) {
      this.model.featureCode = params['FeatureCode'];
    }
    // 特集名
    if ('FeatureName' in params) {
      this.model.featureName = params['FeatureName'];
    }

    this.model.feature = `${this.model.featureCode ?? ''}:${this.model.featureName ?? ''}`;
  }

  /**
   * 選択済みになっているチェックボックスをすべて解除する（候補商品一覧）
   */
  private clearListCheckCandidateList(): void {
    for (const item of this.model.candidateSuggestionGoodsAllList) {
      item.check = false;
    }
  }

  /**
   * 選択済みになっているチェックボックスをすべて解除する（提案商品一覧）
   */
  private clearListCheckSuggestList(): void {
    for (const item of this.model.suggestionGoodsAllList) {
      item.check = false;
    }
  }

  /**
   * 商品選定済みフラグ確認結果 取得
   * @memberof KYMW7002Component
   */
  private getSelectedGoodsFlgResult(): void {
    const userInfo = {
      userType: '',
      payeeSupplierCode: '',
      associatedCompanyId: '',
    };
    if (this.kymw00Model.kymw1001Model.isSupplier()) {
      // ログインユーザが取引先の場合
      userInfo.userType = '1';
      userInfo.payeeSupplierCode = this.model.supplierCode;
    } else if (this.kymw00Model.kymw1001Model.isPlanningSupport()) {
      // ログインユーザが企画支援の場合
      userInfo.userType = '2';
      userInfo.associatedCompanyId = this.model.supplierCode;
    } else {
      userInfo.userType = '0';
    }
    // APIリクエスト
    this.getSelectedGoodsFlgResultService.execute(this.model, userInfo, () => {
      const selectionFlg = this.model.selectedGoodsFlgResult.SelectionFlg;
      if (selectionFlg === KYMW7002SelectionFlg.DRAFT
        || selectionFlg === KYMW7002SelectionFlg.SELECTED
      ) {
        this.getAllSuggestionGoodsListInfo(1);
      }

      this.getApprovalFlowTypeInfo();

      // 商品選定済みフラグ (2: 選定済み) の場合、帳票出力以外のボタンを非活性にし、候補一覧グリッドを非表示にする
      if (selectionFlg === KYMW7002SelectionFlg.SELECTED) {
        this.disableSearchAndEditControl();
      }
    });
  }

  /**
   * 承認フロー区分情報 取得
   * @memberof KYMW7002Component
   */
  private getApprovalFlowTypeInfo(): void {
    // APIリクエスト
    this.getApprovalFlowTypeInfoService.execute(this.model);
  }

  /**
   *  提案候補商品一覧情報取得
   * @memberof KYMW7002Component
   */
  private getAllCandidateSuggestionGoodsList(request: KYMW0300OutputModel, requestPageNo: number): void {

    // APIリクエスト
    this.getCandidateSuggestionGoodsListService.execute(this.model, requestPageNo, request, (response) => {
      // データ取得件数が 1000 件を超えるの場合
      const count = response.CandidateSuggestionGoodsList.length;
      if (count > 1000) {
        // エラーダイアログを表示し、処理を中断
        this.dialogService.openAlertGetMessage('E0524', ['1000']); // 「取得件数が{0}件を超えています。再度条件を設定し、検索してください。」
        return;
      }

      const totalNum = Number(response.TotalNum);
      if (totalNum === 0) {
        return;
      }

      // 最終ページ番号を保持する
      const endPageNo = Math.ceil(totalNum / COUNT_PER_PAGE);
      this.model.endPageNoCandidateList = endPageNo;

      // 取得データをリストに追加する
      const newList: CandidateSuggestionGoods[] = response.CandidateSuggestionGoodsList.map(_ => {
        return {
          check: false,
          PCode: _.PCode,
          ItemCode: _.ItemCode,
          JanCode: _.JanCode,
          GuideGoodsName: _.GuideGoodsName,
          GuideStandardName: _.GuideStandardName,
          MakerName: _.MakerName,
          EBaseSpecCode: _.EBaseSpecCode,
          CatalogId: _.CatalogId,
        };
      });
      this.model.candidateSuggestionGoodsAllList = newList;

      // 一覧表示
      this.showCandidateSuggestionGoodsList(1);
    });
  }

  /**
   *  提案候補商品一覧情報 クリア
   * @memberof KYMW7002Component
   */
  private clearCandidateSuggestionGoodsList(): void {
      const paneNo = 1;

      this.model.currentPageNoCandidateList = paneNo;
      this.model.totalNumCandidateList = 0;
      this.model.startDispNumCandidateList = 0;
      this.model.endDispNumCandidateList = 0;
      this.model.candidateSuggestionGoodsAllList.length = 0;
      this.model.candidateSuggestionGoodsPageList.length = 0;

      this.showCandidateSuggestionGoodsList(paneNo);
  }

  /**
   *  提案候補商品一覧情報 取得
   * @memberof KYMW7002Component
   */
  private showCandidateSuggestionGoodsList(pageNo: number): void {
    const maxCount = this.model.candidateSuggestionGoodsAllList.length; // 最大返却件数を定義
    const startIdx = (pageNo - 1) * COUNT_PER_PAGE;
    const startNum = Math.min(startIdx + 1, maxCount);
    const endNum = Math.min(startIdx + COUNT_PER_PAGE, maxCount);
    const newPageList = this.model.candidateSuggestionGoodsAllList.slice(startIdx, startIdx + COUNT_PER_PAGE);

    // 表示内容更新
    this.model.currentPageNoCandidateList = pageNo;
    this.model.totalNumCandidateList = maxCount;
    this.model.startDispNumCandidateList = startNum;
    this.model.endDispNumCandidateList = endNum;
    this.model.candidateSuggestionGoodsPageList = newPageList;
  }

  /**
   *  提案商品情報一覧 再帰的に全件取得
   * @memberof KYMW7002Component
   */
  private getAllSuggestionGoodsListInfo(requestPageNo: number): void {
    
    // APIリクエスト
    this.getSuggestionGoodsListInfoService.execute(this.model, requestPageNo, (response) => {
      const totalNum = Number(response.TotalNum);
      // 検索結果が 0 件の場合、システムエラーとする
      if (totalNum === 0) {
        this.showSystemErrorAlert();
        return;
      }

      // 最終ページ番号を保持する
      const endPageNo = Math.ceil(totalNum / COUNT_PER_PAGE);
      this.model.endPageNoSuggestList = endPageNo;

      // 取得データをリストに追加する
      const newList: SuggestionGoods[] = response.SuggestionGoodsList.map(_ => {
        return {
          check: false,
          PCode: _.PCode,
          ItemCode: _.ItemCode,
          JanCode: _.JanCode,
          GuideGoodsName: _.GuideGoodsName,
          GuideStandardName: _.GuideStandardName,
          MakerName: _.MakerName,
          PricePattern: _.PricePattern,
          SupplyPriceStandard: Number(_.SupplyPriceStandard),
          SupplyPriceSpecial1: Number(_.SupplyPriceSpecial1),
          SupplyPriceSpecial2: Number(_.SupplyPriceSpecial2),
          ThisTimeSupplyPriceStandard: Number(_.ThisTimeSupplyPriceStandard),
          CostPriceStandard: Number(_.CostPriceStandard),
          CostPriceSpecial1: Number(_.CostPriceSpecial1),
          CostPriceSpecial2: Number(_.CostPriceSpecial2),
          ThisTimeCostPriceStandard: _.ThisTimeCostPriceStandard,
          StockNum: Number(_.StockNum),
          OrderUnitType: _.OrderUnitType,
          NewUnitType: _.NewUnitType,
          PlanNum: Number(_.PlanNum),
          OrderNum: _.OrderNum,
          Remarks: _.Remarks
        };
      });
      this.model.suggestionGoodsAllList.push(...newList);

      // 最終ページまで取得完了したら一覧表示、未完了ならページ番号を増やして再取得
      if (endPageNo <= requestPageNo) {
        this.showSuggestionGoodsList(1);
      } else {
        this.getAllSuggestionGoodsListInfo(++requestPageNo);
      }
    });
  }

  /**
   *  提案商品情報一覧 表示ページ切替
   * @memberof KYMW7002Component
   */
  private showSuggestionGoodsList(pageNo: number): void {
    const maxCount = this.model.suggestionGoodsAllList.length; // 最大返却件数を定義
    const startIdx = (pageNo - 1) * COUNT_PER_PAGE;
    const startNum = Math.min(startIdx + 1, maxCount);
    const endNum = Math.min(startIdx + COUNT_PER_PAGE, maxCount);
    const newPageList = this.model.suggestionGoodsAllList.slice(startIdx, startIdx + COUNT_PER_PAGE);

    // 表示内容更新
    this.model.currentPageNoSuggestList = pageNo;
    this.model.totalNumSuggestList = maxCount;
    this.model.startDispNumSuggestList = startNum;
    this.model.endDispNumSuggestList = endNum;
    this.model.suggestionGoodsPageList = newPageList;
  }

  /**
   *  候補一覧で選択したPコードから提案商品情報に追加する
   * @memberof KYMW7002Component
   */
  private setSuggestionGoodsList(targetPCodeList: string[]): boolean {
    let isListChanged = false;

    // 選定済みPコードの配列を用意
    const selectedPcodes = [] as string[];
    for (const item of this.model.suggestionGoodsAllList) {
      selectedPcodes.push(item.PCode);
    }

    const requestPcodes = [] as string[];
    // 提案商品一覧の選定済みPコードと重複しているかチェック
    const duplicatedPcodes = [] as string[];
    for (const targetPCode of targetPCodeList) {
      if (selectedPcodes.includes(targetPCode)) {
        duplicatedPcodes.push(targetPCode);
      } else {
        // 重複していなければデータ取得対象とする
        requestPcodes.push(targetPCode);
      }
    }

    if (requestPcodes.length === 0) {
      // ダイアログ表示 「選定可能な商品が存在しませんでした。」
      this.dialogService.openAlertGetMessage('E0595');
    } else {
      isListChanged = true;
      // APIリクエスト
      this.getSuggestionGoodsInfoService.execute(this.model, requestPcodes, (newSuggestionGoodsList) => {
        for ( const newGoods of newSuggestionGoodsList) {
          newGoods.ThisTimeSupplyPriceStandard = Number(newGoods.ThisTimeSupplyPriceStandard);
        }
        // 結合してPコードで昇順にソートする
        const conbinedList = [...this.model.suggestionGoodsAllList, ...newSuggestionGoodsList];
        const sortedList = conbinedList.sort((a, b) => a.PCode.localeCompare(b.PCode));
        this.model.suggestionGoodsAllList = sortedList;
        this.model.endPageNoSuggestList = Math.ceil(this.model.suggestionGoodsAllList.length / COUNT_PER_PAGE);
        // 提案一覧の表示内容を初期化
        this.clearListCheckCandidateList();
        this.clearListCheckSuggestList();
        this.showCandidateSuggestionGoodsList(this.model.currentPageNoCandidateList);
        this.showSuggestionGoodsList(1);

        if (duplicatedPcodes.length > 0) {
          // 結果メッセージ「選定済みの商品または、同一の商品が選択されていました。追加可能な商品のみを選定しました。」
          this.dialogService.openAlertGetMessage('I0516');
        }
      });
    }

    return isListChanged;
  }

  /**
   *  提案商品一覧情報 登録
   * @memberof KYMW7002Component
   */
  private registSuggestionGoodsInfo(status: ProcessStatus): void {
    // APIリクエスト
    this.registSuggestionGoodsInfoService.execute(this.model, status, () => {
      if (status === ProcessStatus.SUGGEST) {
        // 完了ダイアログ表示後、親画面に戻す // 結果メッセージ「特集商品の提案が完了しました。」
        this.dialogService.openAlertGetMessage('I0517', undefined, () => {
          this.router.navigate([PARENT_PAGE_ID]);
        });
      } else {
        // 処理完了後、親画面に戻す
        this.router.navigate([PARENT_PAGE_ID]);
      }
    });
  }

  /**
   *  提案商品一覧情報登録 リクエストバリデーション（必須入力チェック）
   * @memberof KYMW7002Component
   */
  private isInvalidRequestForRegister(): boolean {
    // 提案商品は一つ以上必須
    if (this.model.suggestionGoodsAllList.length === 0) {
      return true;
    }

    let isInvalid = false;

    const mediumType = this.model.mediumType;
    const userType = this.model.userType;
    for (const goods of this.model.suggestionGoodsAllList) {
      // 価格パターン
      if (!goods.PricePattern) {
        if (userType === KYMW1001UserType.WHOLESALE ||
          (userType === KYMW1001UserType.PLANNING_SUPPORT && mediumType !== MEDIUM_TYPE_STOCK_ONLY)) {
          isInvalid = true;
          break;
        }
      }

      // 今回供給価格
      if (!(goods.ThisTimeSupplyPriceStandard && goods.ThisTimeSupplyPriceStandard > 0)) {
        if (userType === KYMW1001UserType.WHOLESALE ||
          (userType === KYMW1001UserType.PLANNING_SUPPORT && mediumType !== MEDIUM_TYPE_STOCK_ONLY)) {
          isInvalid = true;
          break;
        }
      }

      // 今回仕入価格
      if (!(goods.ThisTimeCostPriceStandard && goods.ThisTimeCostPriceStandard > 0)) {
        if (userType === KYMW1001UserType.WHOLESALE) {
          isInvalid = true;
          break;
        }
      }

      // 在庫数
      if (!(goods.StockNum && goods.StockNum > 0)) {
        if (userType === KYMW1001UserType.WHOLESALE && mediumType === MEDIUM_TYPE_STOCK_ONLY) {
          isInvalid = true;
          break;
        }
      }

      // 発注単位
      if (!goods.OrderUnitType) {
        if (userType === KYMW1001UserType.WHOLESALE) {
          isInvalid = true;
          break;
        }
      }

      // 新規区分
      if (!goods.NewUnitType) {
        if (userType === KYMW1001UserType.WHOLESALE) {
          isInvalid = true;
          break;
        }
      }

      // 計画数（0 を許容する）
      if (!goods.PlanNum) {
        if ((userType === KYMW1001UserType.WHOLESALE && mediumType !== MEDIUM_TYPE_STOCK_ONLY) ||
          (userType === KYMW1001UserType.PLANNING_SUPPORT && mediumType !== MEDIUM_TYPE_STOCK_ONLY)) {
          isInvalid = true;
          break;
        }
      }

    }

    return isInvalid;
  }

  /**
   *  提案商品一覧出力情報 取得（帳票出力）
   * @memberof KYMW7002Component
   */
  private getSuggestionGoodsListOutputInfo(): void {
    // 前回のダウンロードファイル名（実際にはファイルパス）をクリア
    this.model.outputFileName = '';

    // APIリクエスト
    this.getSuggestionGoodsListOutputInfoService.execute(this.model, () => {
      if (this.model.outputFileName) {
        // ダウンロードファイル名の設定
        const fileName = `特集商品提案一覧表_${this.model.catalogId}_${this.model.mediumName}_${this.model.featureName}_${PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss')}.xlsx`;
        // ファイルダウンロード
        this.fileDownloadConfirmService.show(this.model.outputFileName, fileName);
      }
    });
  }

  /**
   * 検索や編集に関する機能を非活性にする
   * @memberof KYMW7002Component
   */
  private disableSearchAndEditControl(): void {
    this.model.isHiddenCandidateList = true;
    this.model.isDisableButtonSearchGoods = true;
    this.model.isDisableButtonToggleView = true;
    this.model.isDisableButtonSelectGoods = true;
    this.model.isDisableButtonCancelSelection = true;
    this.model.isDisableButtonSaveTemporary = true;
    this.model.isDisableButtonSuggest = true;
    this.model.isDisableGridColumnsSuggestList = true;
    this.model.isEditableColumnSuggestList = false;
  }
}
